import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { getTypographyStyles, DESIGN_TOKENS } from '../../styles/constants';

interface CustomTypographyProps extends TypographyProps {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'body1' | 'body2' | 'caption';
  weight?: 'normal' | 'medium' | 'bold';
}

const CustomTypography: React.FC<CustomTypographyProps> = ({ 
  variant = 'body1',
  weight = 'normal',
  ...props 
}) => {
  const getWeightStyles = () => {
    switch (weight) {
      case 'medium':
        return { fontWeight: DESIGN_TOKENS.typography.fontWeights.medium };
      case 'bold':
        return { fontWeight: DESIGN_TOKENS.typography.fontWeights.bold };
      default:
        return { fontWeight: DESIGN_TOKENS.typography.fontWeights.normal };
    }
  };

  const combinedStyles = {
    ...getTypographyStyles(variant),
    ...getWeightStyles(),
    ...props.sx,
  };

  return (
    <Typography
      {...props}
      sx={combinedStyles}
    />
  );
};

export default CustomTypography;
